import React from 'react';
import '../styles/CreditsBanner.css';

interface CreditsBannerProps {
  credits: number;
  isLoading: boolean;
  onBuyPress: () => void;
}

const CreditsBanner: React.FC<CreditsBannerProps> = ({ credits, isLoading, onBuyPress }) => {
  return (
    <div className="credits-banner">
      <div className="credits-text">
        {isLoading ? (
          <span>Loading credits...</span>
        ) : (
          <span>{credits} {credits === 1 ? 'credit' : 'credits'}</span>
        )}
      </div>
      <button 
        className="buy-button" 
        onClick={onBuyPress}
        disabled={isLoading}
      >
        Buy Credits
      </button>
    </div>
  );
};

export default CreditsBanner;







